"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaiduVerification = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var liveness_1 = require("../../model/liveness");
var service_1 = require("../../../library/base/service");
var BaiduVerification = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(BaiduVerification, _super);
    function BaiduVerification() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '百度活体识别认证接口';
        _this.code = '101095';
        _this.desc = '百度活体识别认证接口';
        _this.requestParams = new liveness_1.BaiduVerificationRequest();
        _this.method = fetch_1.Methods.POSTFILE;
        return _this;
    }
    return BaiduVerification;
}(service_1.BaseService));
exports.BaiduVerification = BaiduVerification;
//# sourceMappingURL=baiduVerification.js.map